import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { CATEGORIES, FontAwesomeIcon, } from '@design-system/font-awesome-icon';
import { Image } from '@design-system/image';
import { CursorPointerWrapper, LinkWrapper, StyledLink } from './LinkWrapper';
import { CONTENT_LIST_SIZES } from '../constants';
export const Cover = ({ children, fallbackIconName = 'image', imageSrc, onClick, path, size, withLink, }) => (_jsxs(LinkWrapper, { ariaHidden: true, onClick: onClick, path: path, tabIndex: -1, withLink: withLink, children: [imageSrc ? (_jsx(StyledImage, { alt: "", src: imageSrc })) : (_jsx(IconWrapper, { "data-testid": "content-list-cover-icon", children: _jsx(FontAwesomeIcon, { color: "primary", height: size === CONTENT_LIST_SIZES.SMALL ? '32px' : '40px', iconName: fallbackIconName, iconType: CATEGORIES.DUOTONE }) })), children] }));
const StyledImage = styled(Image) `
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scale(1);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  ${StyledLink}:hover &,
  ${StyledLink}:focus &,
  ${CursorPointerWrapper}:hover &,
  ${CursorPointerWrapper}:focus & {
    transform: scale(1.1);
  }
`;
const IconWrapper = styled(Box).attrs({
    bg: 'white',
}) `
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  border: solid 1px ${({ theme }) => theme.colors.horizon};
  border-radius: ${({ theme }) => theme.themeVariables.globalBorderRadius}px;
`;
//# sourceMappingURL=Cover.js.map